import { fetchList, generateQueryString } from './utils'
import { i18n } from '../i18n'
import fetch from 'isomorphic-unfetch'
import getConfig from 'next/config'

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig()

export const fetchHistoryYears = async (language = i18n.language, token, query = null) => {
  const userToken = token
  let entityUrl = `/api/v1/history/`
  if (serverRuntimeConfig && serverRuntimeConfig.serverAddress) {
    entityUrl = `${serverRuntimeConfig.serverAddress}${entityUrl}`
  }

  if (query) entityUrl += `?${generateQueryString(query)}`

  try {
    const res = await fetch(entityUrl, {
      headers: {
        Authorization: userToken ? `JWT ${userToken}` : undefined,
        Accept: 'application/json',
        'Accept-Language': language === 0 ? 'ru' : language,
        Secret: publicRuntimeConfig.secret
      }
    })
    return await res.json()
  } catch (error) {
    console.error(error)
  }
  return null
}
